import { Report, ReportFolder_TrackFetchStatus } from 'models';
import { SET_DATA, SET_REPORTS, SET_FETCH_STATUS } from './actionTypes';

// Utils
const toFolderModel = (source, isOwn) => {
  if (_.isEmpty(source) || !_.isArray(source.data)) {
    return [];
  }

  return source.data.map(folder => {
    const { id, name, created_at, shared_to_users, shared_to_teams } = folder;
    return new ReportFolder_TrackFetchStatus({
      id,
      name,
      createdOn: created_at,
      isSharedByOthers: !isOwn,
      sharedToUsers: shared_to_users,
      sharedToTeams: shared_to_teams
    });
  });
};

const initialState = {
  data: [],
  isFetched: false
};

const reportFolders = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      const { own, shared_by_others } = action.payload.data;
      const ownData = toFolderModel(own, true);
      const othersData = toFolderModel(shared_by_others);
      return {
        ...state,
        data: [...ownData, ...othersData],
        isFetched: true
      };

    case SET_REPORTS:
      const { folderId, reports } = action.payload;
      const folder = state.data.find(f => f.id === folderId);
      if (folder) {
        folder.setFetchStatus();
        folder.data = reports.map(
          r =>
            new Report({
              id: r.id,
              name: r.name,
              type: r.type
            })
        );
      }
      return {
        ...state,
        data: [...state.data]
      };

    case SET_FETCH_STATUS:
      return {
        ...state,
        isFetched: action.payload.isFetched
      };

    default:
      return state;
  }
};

export default reportFolders;



// WEBPACK FOOTER //
// ./src/store/metaData/reportFolders/reducer.js